/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum Role {
  AccessAdminPanel = 'access-admin-panel',
  PatentAgent = 'patent-agent',
  SeeAllApplications = 'see-all-applications',
  Admin = 'admin',
}

export function instanceOfRole(value: any): boolean {
  for (const key in Role) {
    if (Object.prototype.hasOwnProperty.call(Role, key)) {
      if (Role[key as keyof typeof Role] === value) {
        return true
      }
    }
  }
  return false
}

export function RoleFromJSON(json: any): Role {
  return RoleFromJSONTyped(json, false)
}

export function RoleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Role {
  return json as Role
}

export function RoleToJSON(value?: Role | null): any {
  return value as any
}
